import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUser, faLock } from '@fortawesome/free-solid-svg-icons';
import { ModalService } from '../../../services/modals/modal.service';
@Component({
  selector: 'app-forgot-password',
  imports: [CommonModule, ButtonModule, ReactiveFormsModule, FontAwesomeModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly modalService = inject(ModalService);
  protected auctionId = input(0);

  protected emailSent = false;
  forgotPasswordForm: FormGroup;
  protected icons = {
    faUser: faUser,
    faLock: faLock,
  }

  constructor(private fb: FormBuilder) {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmit() {
    if (this.forgotPasswordForm.valid) {
      const uri = environment.apiUrl + '/v3/password/recovery-email';
      let requestBody = new HttpParams();
      requestBody = requestBody.set('email', this.email.value);
      requestBody = requestBody.set('auctionId', this.auctionId());
      this.httpClient.post(uri, requestBody).subscribe(() => {
        this.emailSent = true;
      });
    }
  }

  protected closeModal() {
    this.modalService.closeModal('app-forgot-password');
  }

  get email() {
    return this.forgotPasswordForm.get('email')!;
  }

}
